import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faFolder } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Collapse, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LoadingApp from '../../../components/LoadingApp'
import ModalFeedBack from '../../../components/ModalFeedBack'
import { Exame } from '../../../interfaces/entities/ResultadoExame/Exame'
import { ExamCardProps } from '../../../interfaces/props/SaudeOnline/ResultadoExames/ExamCardProps'
import { getResultadoExameByGrupo } from '../../../services/ResultadoExamesServices'
import ExamsTable from './ExamsTable'
import { sxButtonText, sxTitleTableResult } from './sxProps'
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext'


const ExamCard: React.FC<ExamCardProps> = ({ examGroup,page }) => {
  const [openDetails, setOpenDetails] = useState(false);
  const [exam, setExam] = useState<Exame[]>();
  const [loading, setLoading] = useState(false);
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);

  const accessibility = useAccessibility();

  useEffect(()=>{
    setOpenDetails(false);
  },[page]);

  const openDetailsExam = async () => {
    if (!openDetails) {
      setLoading(true);
      var response = await getResultadoExameByGrupo(examGroup.codProcedimento);
      if (response?.status !== 200) {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: 'Falha ao buscar exames.',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setLoading(false);
        return;
      }
      setExam(response.data);
      setLoading(false);
    }
    setOpenDetails(!openDetails)
  }

  return (
    <div className='exam-card-holder' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      <LoadingApp showLoading={loading} />
      <div className='schedule-card-icon-holder'>
        <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faFolder} className='icon-folder-exam' />
      </div>
      <div className="exam-card-info">
        <span className='exam-info' style={accessibility.textStyleAccessibility} tabIndex={0}><b>Tipo de exame:</b> {examGroup.descrLoinc}</span>
        <span className='exam-info' style={accessibility.textStyleAccessibility} tabIndex={0}><b>Data do exame:</b> {examGroup.dataHoraLibera}</span>
        <div>
          <div>
            <Button
              onClick={openDetailsExam} sx={{padding: 0}}
              endIcon={
                <FontAwesomeIcon icon={openDetails ? faChevronUp : faChevronDown} className='expand-icon-exam' />
              }>
              <Typography style={accessibility.textStyleAccessibility} sx={sxButtonText}>Mais informações</Typography>
            </Button>
          </div>
          <Collapse in={openDetails} timeout="auto" unmountOnExit>
            <div>
              <Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTitleTableResult}>Exames</Typography>
              <div>
                {exam && <ExamsTable exames={exam} />}
              </div>
            </div>
          </Collapse>
        </div>
      </div>
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
      />
    </div>
  )
}

export default ExamCard